import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { KeyboardProvider } from 'react-native-keyboard-controller';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import { BoundScrollProvider, ModalProvider } from '@sg/garnish';

import { StripePaymentProvider } from '@order/integrations-stripe';
import { TelemetryProvider } from '@order/Telemetry';

import { NoticeBannersProvider } from './components/NoticeBannersProvider';
import { BrazeProvider } from './context/Braze';
import { CustomerProvider } from './context/Customer';
import { GlobalAppState } from './context/GlobalAppState';

export const Providers = (props: PropsWithChildren) => (
  <SafeAreaProvider>
    <KeyboardProvider>
      <GestureHandlerRootView style={StyleSheet.absoluteFill}>
        <StripePaymentProvider>
          <NoticeBannersProvider>
            <TelemetryProvider>
              <GlobalAppState>
                <ModalProvider>
                  <CustomerProvider>
                    <BrazeProvider>
                      <BoundScrollProvider>{props.children}</BoundScrollProvider>
                    </BrazeProvider>
                  </CustomerProvider>
                </ModalProvider>
              </GlobalAppState>
            </TelemetryProvider>
          </NoticeBannersProvider>
        </StripePaymentProvider>
      </GestureHandlerRootView>
    </KeyboardProvider>
  </SafeAreaProvider>
);
